import { render, staticRenderFns } from "./PrintBasicInformation.vue?vue&type=template&id=4e5a2f62&scoped=true&"
import script from "./PrintBasicInformation.vue?vue&type=script&lang=js&"
export * from "./PrintBasicInformation.vue?vue&type=script&lang=js&"
import style0 from "./PrintBasicInformation.vue?vue&type=style&index=0&id=4e5a2f62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5a2f62",
  null
  
)

/* custom blocks */
import block0 from "./PrintBasicInformation.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e5a2f62')) {
      api.createRecord('4e5a2f62', component.options)
    } else {
      api.reload('4e5a2f62', component.options)
    }
    module.hot.accept("./PrintBasicInformation.vue?vue&type=template&id=4e5a2f62&scoped=true&", function () {
      api.rerender('4e5a2f62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/print/report/PrintBasicInformation.vue"
export default component.exports